import { Box, Card, GridLegacy as Grid } from '@mui/material';
import {
    Caption,
    Heading,
    SubHeading,
    TEXT_SIZE,
    XSMedium
} from '@/typography/Typography';
import { useFormatting } from '@/utils/formatting';
import { cardStyles } from './CardStyles';
import { useTranslation } from 'react-i18next';
import { useContext } from 'react';
import { UserContext } from '@/contexts/user/UserContext';
import Chip from '@/components/shared/Chip';

export interface TipsOverviewProps {
    tipsTotal: number;
    earnedLastShift: number;
    excluded?: boolean;
}

export const TipsOverview = ({
    tipsTotal,
    earnedLastShift,
    excluded = false
}: TipsOverviewProps) => {
    const { getBalanceLabelV2 } = useFormatting();
    const { t } = useTranslation();
    const { company } = useContext(UserContext);

    const totalLabel = excluded
        ? '-'
        : getBalanceLabelV2(tipsTotal, company.currency, {
              showNegativeStyle: true
          });
    const lastShiftLabel = excluded
        ? '-'
        : getBalanceLabelV2(earnedLastShift, company.currency, {
              showNegativeStyle: true
          });

    return (
        <Card style={cardStyles}>
            <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
            >
                <Heading fontSize={TEXT_SIZE.SMALL}>{t('tips.tips')}</Heading>
                {excluded && (
                    <Chip
                        color="muted"
                        label={
                            <XSMedium>
                                {t('tips.excluded_from_instatips')}
                            </XSMedium>
                        }
                        icon={<span></span>}
                    />
                )}
            </Box>

            <Grid mb={2} mt={2} container justifyContent={'space-around'}>
                <Grid
                    textAlign={'center'}
                    item
                    direction={'column'}
                    alignItems={'center'}
                >
                    <SubHeading>{totalLabel}</SubHeading>
                    <Box m={1}></Box>
                    <Caption> {t('tips.total_earned')} </Caption>
                </Grid>

                <Grid
                    item
                    textAlign={'center'}
                    direction={'column'}
                    alignItems={'center'}
                >
                    <SubHeading>{lastShiftLabel}</SubHeading>
                    <Box m={1}></Box>
                    <Caption>{t('tips.earned_last_shift')}</Caption>
                </Grid>
            </Grid>
        </Card>
    );
};
